<template>
  <div
    v-if="showed && isSafari"
    v-loading.fullscreen.lock="fullScreenLoading"
    @click="pay"
    class="noda-payment-button"
    :class="{
      'disabled-payment': disabled,
    }"
  >
    <img
      width="55px"
      src="@/assets/img/apple-pay.svg"
      alt="Apple payment"
    >
  </div>
</template>

<script>
import isSafari from "@/shared/is-safari";
import nodaMixin from "./noda-mixin";
import paymentMixin from "../payment-mixin";

export default {
  name: "NodaApplePay",
  mixins: [nodaMixin, paymentMixin],
  computed: {
    isSafari,
  },
  data() {
    return {
      formType: "checkout_form_applepay",
      methodType: "Noda Apple Pay",
    };
  },
};
</script>

<style lang="scss" scoped src="./noda-button.scss"></style>
